import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { feedbackMutationCache } from '../lib/feedback';

export function BusinessSessionScope({ identity, children }: { identity: string; children: ReactNode }) {
  return <SessionCache key={identity}>{children}</SessionCache>;
}

function SessionCache({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient({ mutationCache: feedbackMutationCache(), defaultOptions: { mutations: { retry: false } } }));
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
